import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { Button } from 'react-bootstrap';

interface ViewButtonComponentProps {
  onClick: () => void;
}

const ViewButtonComponent: React.FC<ViewButtonComponentProps> = ({ onClick }) => {
  return (
    <>
      <Button variant='light' onClick={onClick}>
        <FontAwesomeIcon icon={faEye} color='#FF9A62' />
      </Button>
    </>
  )
}

export default ViewButtonComponent;